module.exports = __webpack_public_path__ + "img/204.rug.438ba2c4.svg";